export default __webpack_public_path__ + "static/media/completed-white.2960ea8d.svg";